import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to develop strategic long-term goals.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Have you ever gone to the supermarket when hungry?</p>
                                            <div className="border_subtitle">Mmmm...</div>
                                            <p>If so, once at home did you find a number of unusual items
                                                you had no intention of buying, such
                                                as doughnuts, pizzas with new toppings or delicious looking
                                                desserts, at the expense of basic
                                                foods such as bread, eggs, or potatoes? If this has happened
                                                to you, don’t worry, you’re not alone.
                                                It seems we find it notoriously difficult to delay our
                                                short-term needs or desires, for long-term
                                                requirements.<a className="superscripttext"
                                                                href="further_info.php?course=300"><sup>1</sup></a>After
                                                a spontaneous shop (or maybe once we’ve eaten the offending
                                                items) we
                                                are struck by a bout of sudden guilt from the knowledge that
                                                we have indulged in purchasing
                                                unnecessary treats at the expense of our basic needs.</p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Projection bias</div>
                                                <p>Researchers<a className="superscripttext"
                                                                 href="further_info.php?course=300"><sup>2</sup></a> have
                                                    proposed that this is where we are out of touch with our
                                                    ‘future emotional self’
                                                    – that is, we find it hard to identify with predicting
                                                    our future needs, because our current emotional
                                                    state overrides these needs. This is known as the
                                                    ‘projection bias’. This happens despite us having
                                                    experience of similar occasions (previous shops whilst
                                                    hungry) and their undesirable consequences
                                                    (lots of junk food and a serious lack of staples in the
                                                    house). Simply put, projection bias means
                                                    we ignore our long-term needs in favour of short-term
                                                    gratification. However, if we are to learn to
                                                    strategically predict our long-term needs we need to
                                                    combat this bias. </p>
                                                <p>In this example, we can start by not shopping when we are
                                                    hungry, as this increases the
                                                    likelihood of us buying only what we need. Mentally,
                                                    this involves projecting our current
                                                    emotional state (such as hunger) into the future to
                                                    envisage how we are likely to feel
                                                    (guilty if we buy treats and fulfilled if we stick to
                                                    the plan). So when developing strategic
                                                    long-term goals it is important to plan for the
                                                    projection bias. </p>
                                            </div>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Seeing a vision of the future is critical to planning a
                                                strategy and avoiding pitfalls like the projection bias.
                                                This tool is about <span className="green"><strong>how to develop
strategic long-term goals</strong></span> and will help you</p>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}